module.exports = __webpack_public_path__ + "img/图片12.f5e0ece7.png";